import {
  Directive,
  Input,
  TemplateRef,
  HostListener,
  OnInit,
  ElementRef,
  ComponentRef,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import {
  OverlayRef,
  Overlay,
  OverlayPositionBuilder,
} from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { AndromedaCustomTooltipComponent } from './andromeda-custom-tooltip.component';
@Directive({
  selector: '[libAndromedaTooltip]',
  // standalone: false
})
export class AndromedaCustomTooltipDirective implements OnInit, OnDestroy {
  @Output() clickOutside = new EventEmitter<void>();
  @Input('libAndromedaTooltip') content: string | TemplateRef<any>;
  @Input() andromedaTooltipHost: boolean;

  private overlayRef: OverlayRef;

  constructor(
    // eslint-disable-next-line no-unused-vars
    private overlayPositionBuilder: OverlayPositionBuilder,
    // eslint-disable-next-line no-unused-vars
    private elementRef: ElementRef,
    // eslint-disable-next-line no-unused-vars
    private overlay: Overlay
  ) {}

  @HostListener('mouseenter')
  show(): void {
    this.overlayRef.addPanelClass('translated');
    const tooltipPortal = new ComponentPortal(AndromedaCustomTooltipComponent);
    this.overlayRef.detach();
    const tooltipRef: ComponentRef<AndromedaCustomTooltipComponent> =
      this.overlayRef.attach(tooltipPortal);
    const eRef: HTMLButtonElement = this.elementRef.nativeElement;
    const left = eRef.getBoundingClientRect().left;
    const width = eRef.getBoundingClientRect().width;
    tooltipRef.instance.marginLeft = left + width / 2 + 2.5 + 'px';
    if (typeof this.content === 'string') {
      tooltipRef.instance.text = this.content;
    } else {
      tooltipRef.instance.content = this.content;
    }
  }

  @HostListener('mouseleave', ['$event'])
  hide(): void {
    this.overlayRef.detach();
  }

  ngOnInit(): void {
    const positionStrategy = this.overlayPositionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions([
        {
          originX: 'center',
          originY: 'bottom',
          overlayX: 'center',
          overlayY: 'top',
        },
      ]);
    this.overlayRef = this.overlay.create({ positionStrategy });
  }

  ngOnDestroy(): void {
    this.overlayRef?.detach();
  }
}
